// Actions
export const ADD_COLLECTION = 'companyExperience/entities/candidateNotes/ADD_COLLECTION'
export const ADD_ITEM = 'companyExperience/entities/candidateNotes/ADD_ITEM'
export const UPDATE_ITEM = 'companyExperience/entities/candidateNotes/UPDATE_ITEM'
export const DELETE_ITEM = 'companyExperience/entities/candidateNotes/DELETE_ITEM'

// Action Creators
export const addCollection = collection => ({
  type: ADD_COLLECTION,
  payload: collection.map(item => addItem(item.id, item)),
})

export const addItem = (id, item) => ({
  type: ADD_ITEM,
  meta: { id },
  payload: item,
})

export const updateItem = (id, item) => ({
  type: UPDATE_ITEM,
  meta: { id },
  payload: item,
})

export const deleteItem = id => ({
  type: DELETE_ITEM,
  meta: { id },
})

// Reducers
const defaultEntity = {}

const entity = (state = defaultEntity, { type, payload }) => {
  switch (type) {
    case ADD_ITEM:
    case UPDATE_ITEM:
      return { ...state, ...payload }

    default:
      return state
  }
}

const defaultMap = {}

const map = (state = defaultMap, { type, meta, payload }) => {
  switch (type) {
    case ADD_COLLECTION:
      return {
        ...state,
        ...payload.reduce((map, item) => {
          map[item.meta.id] = entity(state[item.meta.id], { type: item.type, payload: item.payload })
          return map
        }, {}),
      }

    case ADD_ITEM:
    case UPDATE_ITEM:
      return {
        ...state,
        [meta.id]: entity(state[meta.id], { type, payload }),
      }

    case DELETE_ITEM:
      const newState = { ...state }
      delete newState[meta.id]
      return newState

    default:
      return state
  }
}

export default map

export const getCandidateNoteMap = state => state.entities.candidateNotes || defaultMap
export const getCandidateNoteItem = (state, id) => state.entities.candidateNotes[id] || defaultEntity
